import { createSlice } from "@reduxjs/toolkit";
import { reducerPaths } from "../../app/reducerPaths";

const initialState = {
  vehicle_id: null,
  images: [],
};

const carEstimateSlice = createSlice({
  name: reducerPaths.carEstimateSlice,
  initialState,
  reducers: {
    setCarEstimateVehicleId: (state, action) => {
      state.vehicle_id = action.payload;
    },
    setImages: (state, action) => {
      state.images = action?.payload;
    },
  },
});

export const { 
  setCarEstimateVehicleId,
  setImages
} = carEstimateSlice.actions;

export default carEstimateSlice.reducer;
